export const icons = [
    'user',
    'info',
    'error',
    'warning',
    'success',
    'search',
    'check',
    'chevron-down',
    'chevron-left',
    'chevron-right',
    'round-checkmark',
    'logo-uptimise',
    'logo-short',
    'menu',
] as const;
export type Icon = (typeof icons)[number];

// Note: type guard
export function isIcon(icon: string): icon is Icon {
    return icons.includes(icon as Icon);
}
